import { motion } from 'framer-motion';
import { AnimatePresence } from 'framer-motion';
import { useState } from 'react';

interface NavbarProps {
  scrolled: boolean;
}

export default function Navbar({ scrolled }: NavbarProps) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <motion.nav
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-white/95 backdrop-blur-lg shadow-lg'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <motion.div className="flex items-center gap-2 cursor-pointer">
            <div className="w-8 h-8 flex items-center justify-center">
              <i className="ri-drop-fill text-3xl text-honey-500"></i>
            </div>
            <span className={`text-2xl font-bold ${scrolled ? 'text-charcoal-800' : 'text-white'}`}>
              HoneyJar
            </span>
          </motion.div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            <a href="#about" className="text-charcoal-800 hover:text-honey-600 font-semibold transition-all">
              About
            </a>
            <a href="#missions" className="text-charcoal-800 hover:text-honey-600 font-semibold transition-all">
              Missions
            </a>
            <a href="#rewards" className="text-charcoal-800 hover:text-honey-600 font-semibold transition-all">
              Rewards
            </a>
            <a href="#partners" className="text-charcoal-800 hover:text-honey-600 font-semibold transition-all">
              Partners
            </a>
            <button
              onClick={() => window.REACT_APP_NAVIGATE('/login')}
              className="bg-gradient-to-r from-honey-500 to-amber-600 text-white px-6 py-3 rounded-xl font-bold hover:shadow-xl transition-all whitespace-nowrap"
            >
              Member Portal
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center"
          >
            <i className={`${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl text-charcoal-800`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        <AnimatePresence>
          {isMenuOpen && (
            <motion.div
              initial={{ y: -100 }}
              animate={{ y: 0 }}
              exit={{ y: -100 }}
              className="md:hidden flex flex-col gap-4 p-4 bg-white/95 backdrop-blur-lg shadow-lg"
            >
              <a href="#about" className="block py-3 text-charcoal-800 hover:text-honey-600 font-semibold transition-all">
                About
              </a>
              <a href="#missions" className="block py-3 text-charcoal-800 hover:text-honey-600 font-semibold transition-all">
                Missions
              </a>
              <a href="#rewards" className="block py-3 text-charcoal-800 hover:text-honey-600 font-semibold transition-all">
                Rewards
              </a>
              <a href="#partners" className="block py-3 text-charcoal-800 hover:text-honey-600 font-semibold transition-all">
                Partners
              </a>
              <button
                onClick={() => window.REACT_APP_NAVIGATE('/login')}
                className="w-full mt-4 bg-gradient-to-r from-honey-500 to-amber-600 text-white px-6 py-3 rounded-xl font-bold hover:shadow-xl transition-all whitespace-nowrap"
              >
                Member Portal
              </button>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </motion.nav>
  );
}
